import config from 'json!../../../../config/oauth.json';
import queryString from 'query-string';

class AuthService {
    constructor($state, $http, OAuth, OAuthToken) {
        'ngInject';

        this.$state = $state;
        this.$http = $http;
        this.OAuth = OAuth;
        this.OAuthToken = OAuthToken;
        this.authenticated = this.OAuth.isAuthenticated();
    }

    login(username, password) {

        //authenticate and set the auth header
        let credentials = {username: username, password: password};
        return this.OAuth.getAccessToken(credentials).then((response) => {
            this.authenticated = true;
            return response;
        });
    }

    // TODO Create a PR in angular-oauth2 revoking access_token and refresh_token
    revokeAccessToken(accessToken) {
      let data = {
        client_id: config.clientId,
        token_type_hint: 'access_token',
        token: accessToken
      };

      if (null !== config.clientSecret) {
        data.client_secret = config.clientSecret;
      }

      data = queryString.stringify(data);

      let options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Bearer ' + accessToken
        }
      };

      return this.$http.post(`${config.baseUrl}${config.revokePath}`, data, options).then((response) => {
        return response;
      });
    }

    logout() {
        let accessToken = this.OAuthToken.getAccessToken();
        return this.OAuth.revokeToken().then((response)=> {
          return response;
        })
        .then((response) => {
          return this.revokeAccessToken(accessToken).then((response) => {
            this.authenticated = this.OAuth.isAuthenticated();
            return response;
          });
        })
        .catch((error) => {
          return error;
        });
    }

    getAccessToken() {
        return this.OAuthToken.getAccessToken();
    }
}

export default AuthService;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.service.js